import languageCodes from '../../../consts/localization/languageCodes';
import {CS} from './CS';
import {EN} from './EN';

const getDefaultDictionaryFromCode = (languageCode) => {
    switch (languageCode) {
        case languageCodes.CS:
            return CS;
        case languageCodes.EN:
            return EN;
        default:
            return EN;
    }
};

export default {
    getDefaultDictionaryFromCode,
};
